import { DateTimeFormatter, ZonedDateTime } from '@js-joda/core';

import { extractValidEmails } from '#/shared/utils/formHelper';

import { TimesheetVerificationFormValues } from '../types/TimesheetVerificationFormValues';
import { VerifyTimesheetApiData } from '../types/VerifyTimesheetApi';

type MapTimesheetVerificationFormValuesToVerifyTimesheetApiData = {
  formValues: TimesheetVerificationFormValues;
  paidBreakExceptionIsEnabled: boolean;
};

/**
 * Maps `TimesheetVerificationFormValues` data to the `VerifyTimesheetApiData`.
 * @param params The parameters object containing form values and feature flag values
 */
export const mapTimesheetVerificationFormValuesToVerifyTimesheetApiData = (
  params: MapTimesheetVerificationFormValuesToVerifyTimesheetApiData,
): VerifyTimesheetApiData => {
  const { formValues, paidBreakExceptionIsEnabled } = params;
  const emailCopyTo: string[] | undefined = extractValidEmails(formValues.verifierEmails);

  const data: VerifyTimesheetApiData = {
    verified_by: {
      name: formValues.verifierName.trim(),
      role: formValues.verifierRole.trim(),
      department: formValues.verifierDepartment?.trim() || undefined, // || instead of ?? to ensure undefined is passed
      notes: formValues.verifierNotes?.trim() || undefined, // || instead of ?? to ensure undefined is passed,
      verified_at: ZonedDateTime.now().format(DateTimeFormatter.ISO_OFFSET_DATE_TIME),
    },
    approver: {
      name: formValues.approverName.trim(),
      email: formValues.approverEmail.trim(),
    },
    email_copy_to: emailCopyTo,
  };

  if (paidBreakExceptionIsEnabled) {
    return {
      ...data,
      paid_break_decisions: formValues.paidBreakExceptions?.map(exception => ({
        shift_date: exception.shift_date,
        approver_decision: exception.approver_decision,
        approver_notes: exception.approver_notes?.trim() || undefined,
      })),
    };
  }

  return data;
};
